import React, { useState, useEffect } from "react";
import {
  Table,
  Spinner,
 
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { deviceAllSessionAPI } from "../services/Device";
import TableHeader from "../components/TableHeader";

const nonStimCache = {
  data: null,
  timestamp: null,
};

const NonStimulation = () => {
  const history = useHistory();
  const [deviceSession, setDeviceSession] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [filterBy, setFilterBy] = useState("Last Stim Recoded");
  const [searchValue, setSearchValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 50;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const validSearchData = searchData.filter((user) => user?.data?.prcId);
  const currentRecords = validSearchData.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(validSearchData.length / recordsPerPage);

  const handleToggle = () => setIsOpen(!isOpen);

  const refreshlist = () => {
    setLoading(true);
    document.getElementById("refreshbtn").className = "fas fa-sync fa-spin";
    nonStimCache.data = null;
    getAllDeviceSession(false, true);
  };

  const convertDataToHex = (data) => {
    return parseInt(data, 10).toString(16).padStart(4, "0");
  };

  const getBytes = (hexString) => {
    if (hexString.length !== 4) {
      throw new Error("Hex string must be 4 characters long");
    }
    const upperByte = hexString.slice(0, 2);
    const lowerByte = hexString.slice(2, 4);
    return { upperByte, lowerByte };
  };

  useEffect(() => {
    let isMounted = true;
    if (nonStimCache.data) {
      setDeviceSession(nonStimCache.data);
      setSearchData(nonStimCache.data);
      getAllDeviceSession(true, isMounted);
    } else {
      getAllDeviceSession(false, isMounted);
    }
    return () => { isMounted = false; };
  }, []);

  const applyFilters = () => {
    if (deviceSession.length === 0) return;
    let filteredList = deviceSession;
    if (searchValue) {
      filteredList = deviceSession?.filter((item) => {
        if (item?.data?.prcId && filterBy === "Last Stim Recoded") {
          return timeFormatMinSec(item?.data?.updatedAt).includes(searchValue);
        }
      });
    }
    setSearchData(filteredList);
  };

  const handleFilterByChange = (value) => {
    setSearchValue("");
    setFilterBy(value);
  };

  const handleSearchInputChange = (e) => setSearchValue(e.target.value);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

  useEffect(() => {
    applyFilters();
  }, [filterBy, searchValue]);

  const identifyUsersWithInactiveStim = (deviceData) => {
    const currentTime = Date.now();
    const filteredData = deviceData
      ? deviceData.filter((item) => item.createdAt <= currentTime)
      : [];
    const groupedData = filteredData.reduce((groups, item) => {
      const { prcId } = item;
      if (!groups[prcId]) groups[prcId] = [];
      groups[prcId].push(item);
      return groups;
    }, {});
    const usersWithEventErrFvr = Object.entries(groupedData)
      .filter(([prcId, data]) => {
        const eventTrtActCount =
          prcId && data.filter((item) => item.eventId === "EVENT_TRT_ACTIVE").length;
        return eventTrtActCount >= 3;
      })
      .map(([prcId, data]) => {
        const filteredData = data.filter((item) => {
          const hexData = convertDataToHex(item.data);
          const { lowerByte } = getBytes(hexData);
          return prcId && item.eventId === "EVENT_TRT_ACTIVE" && lowerByte === "00";
        });
        const lastEventImp = filteredData.length > 0 ? filteredData[0] : {};
        return { prcId, data: lastEventImp, groupedData };
      });
    return usersWithEventErrFvr;
  };

  const getAllDeviceSession = async (isBackground = false, isMounted = true) => {
    try {
      if (!isBackground) setLoading(true);
      const data = await deviceAllSessionAPI();
      if (!isMounted) return;
      const usersWithInactiveStim = identifyUsersWithInactiveStim(data?.sessions || []);
      nonStimCache.data = usersWithInactiveStim;
      setDeviceSession(usersWithInactiveStim);
      if (!isBackground) setSearchData(usersWithInactiveStim);
    } catch (error) {
      if (!isMounted) return;
      console.error("Failed to load:", error);
    } finally {
      if (isMounted) {
        setLoading(false);
        const btn = document.getElementById("refreshbtn");
        if (btn) btn.className = "fas fa-sync fa-stop";
      }
    }
  };

  function downloadCSV(csv, filename) {
    var csvFile = new Blob([csv], { type: "text/csv" });
    var downloadLink = document.createElement("a");
    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

  function exportTableToCSV() {
    let csv = [];
    let rows = document.querySelectorAll("table tr");
    for (let i = 0; i < rows.length; i++) {
      let row = [], cols = rows[i].querySelectorAll("td, th");
      for (let j = 0; j < cols.length; j++) row.push(cols[j].innerText);
      csv.push(row.join(","));
    }
    downloadCSV(csv.join("\n"), "NonStimulation");
  }

  const timeFormatMinSec = (dateStr) => {
    if (!dateStr || dateStr == "undefined" || dateStr < 1520160669214) return " ";
    let date = new Date(parseInt(dateStr));
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = (" 0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2) + " " + ampm;
    let newDate = new Date(parseInt(dateStr)).toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
    return newDate + " (" + strTime + ")";
  };

  const showRecords = () => {
    let sortedList = [...currentRecords];
    if (sortColumn) {
      sortedList.sort((a, b) => {
        if (sortOrder === "asc") return a?.data?.[sortColumn]?.toString().localeCompare(b?.data?.[sortColumn]);
        else return b?.data?.[sortColumn]?.toString().localeCompare(a?.data?.[sortColumn]);
      });
    }

    if (loading) {
      return (
        <tr>
          <td colSpan="3" style={{ textAlign: "center", padding: "60px 0" }}>
            <Spinner animation="border" style={{ width: "2.5rem", height: "2.5rem", color: "#525f7f" }} />
            <div style={{ marginTop: 12, color: "#6c757d", fontSize: 14 }}>Loading...</div>
          </td>
        </tr>
      );
    }

    if (sortedList?.length === 0) {
      return (
        <tr>
          <td colSpan="3" style={{ textAlign: "center", padding: "60px 0", color: "#6c757d" }}>
            No Record Found!
          </td>
        </tr>
      );
    }

    return sortedList.map((user, index) => {
     
     const handleClick = (event) => {
  event.preventDefault();
  history.push({
    pathname: `/device/${user?.data?.deviceId}`,
    // Remove state entirely — let DeviceSessions fetch fresh
  });
};
      return (
        <tr key={index}>
          <td style={{ textAlign: "left" }}>
            <a href="#" onClick={handleClick}>{user?.data?.prcId || "-"}</a>
          </td>
          <td style={{ textAlign: "left" }}>{user?.data?.subjectId || "-"}</td>
          <td style={{ textAlign: "left" }}>{timeFormatMinSec(user?.data?.updatedAt) || "-"}</td>
        </tr>
      );
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", background: "#fff", height: "100vh", overflow: "hidden" }}>
      <TableHeader
  title="Non-Compliant Stim"
  onRefresh={refreshlist}
  onDownload={exportTableToCSV}
  totalCount={validSearchData.length > 0 ? validSearchData.length : null}
  hasMore={false}
       filterContent={
  <div style={{ display: "flex", gap: 8, alignItems: "center", maxWidth: 500 }}>
    <Dropdown isOpen={isOpen} toggle={handleToggle} style={{ flexShrink: 0 }}>
      <DropdownToggle caret>Filter By: {filterBy}</DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => handleFilterByChange("Last Stim Recoded")}>
          Last Stim Recoded
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Input
      type="text"
      placeholder={`Enter ${filterBy}`}
      value={searchValue}
      onChange={handleSearchInputChange}
      style={{ flex: 1 }}
    />
  </div>
}
      />

      <div style={{ overflowY: "auto", background: "#fff" }}>
        <Table striped hover responsive bordered className="align-items-center table-flush" style={{ margin: 0 }}>
          <thead className="thead-light" style={{ cursor: "pointer", position: "sticky", top: 0, zIndex: 1 }}>
            <tr>
              <th scope="col" style={{ textAlign: "left" }} onClick={() => handleSort("prcId")}>Ring Id</th>
              <th scope="col" style={{ textAlign: "left" }} onClick={() => handleSort("subjectId")}>Subject Id</th>
              <th scope="col" style={{ textAlign: "left" }} onClick={() => handleSort("updatedAt")}>Last Stim Recorded</th>
            </tr>
          </thead>
          <tbody>
            {showRecords()}
            {validSearchData.length > 50 && !loading && (
              <tr>
                <td colSpan="3" style={{ textAlign: "right", padding: "12px 16px" }}>
                  <div style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(prev => prev - 1)}
                      style={{
                        padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6",
                        background: currentPage === 1 ? "#f8f9fa" : "#fff",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer", fontWeight: 500,
                      }}
                    >←</button>
                   <div style={{ padding: "6px 14px", borderRadius: 6, background: "#f2f0f0", color: "#0e0d0d", fontWeight: 500, fontSize: 14 }}>
  {indexOfFirstRecord + 1}–{Math.min(indexOfLastRecord, validSearchData.length)} of {validSearchData.length}
</div>
                    <button
                      disabled={currentPage === totalPages || totalPages === 0}
                      onClick={() => setCurrentPage(prev => prev + 1)}
                      style={{
                        padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6",
                        background: currentPage === totalPages ? "#f8f9fa" : "#fff",
                        cursor: currentPage === totalPages ? "not-allowed" : "pointer", fontWeight: 500,
                      }}
                    >→</button>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default NonStimulation;